import { forwardRef } from 'react';
import { Paper, PaperProps, Stack } from '@rossum/ui/material';
import {
  GridColumnHeaders,
  GridColumnHeadersProps,
} from '@rossum/ui/x-data-grid-pro';

type ColumnHeaderPaperProps = GridColumnHeadersProps & {
  elevation?: PaperProps['elevation'];
};

export const ColumnHeaderPaper = forwardRef<
  HTMLDivElement,
  ColumnHeaderPaperProps
>(({ elevation, ...rest }: ColumnHeaderPaperProps, ref) => {
  const isPaperBackground = typeof elevation === 'number';

  return (
    <Stack
      component={isPaperBackground ? Paper : 'div'}
      elevation={elevation}
      sx={{
        backgroundColor: t =>
          t.palette.background[isPaperBackground ? 'paper' : 'default'],
        boxShadow: 'none',
        borderRadius: 0,
      }}
    >
      <GridColumnHeaders ref={ref} {...rest} />
    </Stack>
  );
});
